module.exports = __webpack_public_path__ + "static/img/41.6c0f9d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/41.png
// module id = Ij9R
// module chunks = 1